<template>
  <svg width="14" height="24" viewBox="0 0 14 14" fill="#9FA1AA" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.39228 1.44412C2.39228 0.833008 1.89753 0.333008 1.29282 0.333008C0.688117 0.333008 0.193359 0.833008 0.193359 1.44412V12.5552C0.193359 13.1663 0.688117 13.6663 1.29282 13.6663C1.89753 13.6663 2.39228 13.1663 2.39228 12.5552V1.44412ZM8.79115 6.99968L13.0571 11.3219C13.4833 11.7492 13.4882 12.4441 13.0681 12.8775C12.6393 13.3108 11.9466 13.3108 11.5178 12.8775L6.47128 7.77745C6.26543 7.56985 6.14975 7.28802 6.14975 6.99412C6.14975 6.70022 6.26543 6.41839 6.47128 6.21079L11.5178 1.11079C11.7947 0.830928 12.1984 0.72163 12.5766 0.824066C12.9549 0.926501 13.2504 1.22511 13.3518 1.6074C13.4531 1.98969 13.345 2.39759 13.0681 2.67745L8.79115 6.99968Z" fill="#9FA1AA"></path></svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
